module.exports = __webpack_public_path__ + "static/media/importFlybook2.39a0d3cf.png";